import { ArrowBuilder } from './ArrowBuilder';
import { PolygonalArrow } from '../PolygonalArrow';
import { ArrowType, IndicatorType } from '../../enums';
export class PolygonalArrowBuilder extends ArrowBuilder {
    constructor(base) {
        super();
        this.arrowArea = undefined;
        this.indicatorScale = undefined;
        this.indicatorPosition = undefined;
        this.indicatorType = undefined;
        this.setArea = (arrowArea) => {
            this.arrowArea = arrowArea;
            return this;
        };
        this.setIndicatorScale = (indicatorScale) => {
            this.indicatorScale = indicatorScale;
            return this;
        };
        this.setIndicatorPosition = (indicatorPosition) => {
            this.indicatorPosition = indicatorPosition;
            return this;
        };
        this.setIndicatorType = (indicatorType) => {
            this.indicatorType = indicatorType;
            return this;
        };
        this.build = () => {
            var _a;
            if (this.tourSceneGuid === undefined ||
                this.sceneIndex === undefined ||
                this.fov === undefined ||
                this.indicatorPosition === undefined ||
                this.indicatorScale === undefined ||
                this.arrowArea === undefined) {
                throw Error('PolygonalArrowBuilder does not have base or properties are not set properly');
            }
            const arrow = new PolygonalArrow(this.tourSceneGuid);
            arrow.sceneIndex = this.sceneIndex;
            arrow.fov = this.fov;
            arrow.arrowPositionConfiguration = {
                arrowPositionType: ArrowType.Polygon,
                arrowPosition: {
                    indicatorType: (_a = this.indicatorType) !== null && _a !== void 0 ? _a : IndicatorType.PolygonalShape,
                    indicatorPosition: this.indicatorPosition,
                    indicatorScale: this.indicatorScale,
                    arrowArea: this.arrowArea,
                },
            };
            return arrow;
        };
        this.sceneIndex = base === null || base === void 0 ? void 0 : base.sceneIndex;
        this.tourSceneGuid = base === null || base === void 0 ? void 0 : base.tourSceneGuid;
        this.fov = base === null || base === void 0 ? void 0 : base.fov;
        this.arrowArea = base === null || base === void 0 ? void 0 : base.arrowPositionConfiguration.arrowPosition.arrowArea;
        this.indicatorScale = base === null || base === void 0 ? void 0 : base.arrowPositionConfiguration.arrowPosition.indicatorScale;
        this.indicatorPosition = base === null || base === void 0 ? void 0 : base.arrowPositionConfiguration.arrowPosition.indicatorPosition;
        this.indicatorType = base === null || base === void 0 ? void 0 : base.arrowPositionConfiguration.arrowPosition.indicatorType;
    }
}
